import React from "react";
import { Bar as ReChartsBar } from "recharts";

import { useScoped } from "~/tools/impulse";

import type { ChartDataPoint } from "./_create-chart-data-points";
import { getLineColorByIndex } from "./_get-line-color-by-index";
import type { LegendContentState } from "./_legend-content";

interface BarProps {
	name: string;
	index: number;
	legendState: LegendContentState;
}

export const Bar: React.FC<BarProps> = React.memo(({ name, legendState, index }) => {
	const hide = useScoped((scope) => !legendState.isLabelVisible(scope, name), [legendState, name]);
	const dataKey = React.useCallback(({ values }: ChartDataPoint) => values[index], [index]);

	return (
		<ReChartsBar
			dataKey={dataKey}
			fill={getLineColorByIndex(index)}
			hide={hide}
			isAnimationActive={false}
			legendType="line"
			name={name}
			zIndex={500}
		/>
	);
});

if (import.meta.env.DEV) {
	Bar.displayName = "TimeSeriesChart.Bar";
}
